export class PlaceLocationFilterGroup {
  _id: string;

  // id?: string;
  title: string;
  cities: string[] = [];

  tempTitle: string;
  isEditing: boolean = false;
  isSelected: boolean = false;

  constructor(title: string) {
    this.title = title;
    // this.id = guid();
  }
}

export class EventLocationFilterGroup {
  _id: string;

  // id?: string;
  title: string;
  cities: string[] = [];

  tempTitle: string;
  isEditing: boolean = false;
  isSelected: boolean = false;

  constructor(title: string) {
    this.title = title;
    // this.id = guid();
  }
}




// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/customization/location.filter.settings/location.filter.settings.provider.ts